import { isInIframe } from '@shared/utils/isInIframe';
import { useEventUserRole } from '@shared/components/AuthProvider';
import type { PageKind } from '@graphql/generated-base';
import { toPageContainerSlug } from '@shared/utils/migratedCustomPages';
import { useGuestPageContainerBySlugQuery } from '../Custom.graphql.generated';
import { useIsStaysRedesignActive } from '../components/Honeymoon/useIsStaysRedesignActive';

// toPageContainerSlug aligns this hook's cache key with useFetchCustomPageData
// (registrylinks → registry; no-op elsewhere). Pass `pageKind` so a userCustom squatter
// (CORE-6456) is fetched by its literal slug and matches useFetchCustomPageData's cache key.
export const useCustomData = (_eventId: string, eventHandle: string, pageSlug: string, pageKind?: PageKind | null) => {
  const isPreviewing = isInIframe();
  const { isAdmin } = useEventUserRole();
  const containerSlug = toPageContainerSlug(pageSlug, pageKind);
  const isStaysRedesignActive = useIsStaysRedesignActive();

  const {
    data: pageContainerData,
    loading,
    error,
  } = useGuestPageContainerBySlugQuery({
    variables: {
      payload: {
        eventName: eventHandle,
        pageSlug: containerSlug,
      },
      isAdminDashboard: isPreviewing && isAdmin,
    },
    batchMode: 'fast',
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: false,
    // SSR participation scoped to redesign — non-redesign keeps ssr=false (matches develop).
    ssr: isStaysRedesignActive,
    skip: !containerSlug,
  });

  return {
    loading,
    pageContainerBySlug: pageContainerData?.pageContainerBySlug,
    error,
    isAdmin,
  };
};
